export default __webpack_public_path__ + "static/media/course3.04357444.webp";